import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import storage from '../storage';

const isAuthenticated =
  storage.getItem('token') !== undefined &&
  storage.getItem('token') &&
  storage.getItem('token') !== ''
    ? true
    : false;

const GuestRoute = ({ component: Component, ...restProps }) => (
  <Route
    {...restProps}
    render={(props) =>
      !isAuthenticated ? <Component {...props} /> : <Redirect to="/algos" />
    }
  />
);

GuestRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default GuestRoute;
